export type OperationsArea = 'admin' | 'workers';
export type OperationsUser = { isStaff?: boolean; isAdmin?: boolean; isWorker?: boolean };
export type OperationsLink = { label: string; icon: string; path: string };
export type OperationsGroup = { label: string; links: OperationsLink[] };

export function operationsHome(area: OperationsArea, user: OperationsUser): string {
  return area === 'workers' ? '/workers/dashboard' : user.isStaff ? '/admin/staff/businesses' : '/admin/dashboard';
}

export function operationsNavigation(area: OperationsArea, user: OperationsUser): OperationsGroup[] {
  if (area === 'admin' && user.isStaff) {
    return [{ label: 'Plataforma', links: [
      { label: 'Negocios y comisiones', icon: 'storefront', path: '/admin/staff/businesses' },
      { label: 'Cobros de Onticket', icon: 'account_balance_wallet', path: '/admin/staff/payments' },
      { label: 'Liquidaciones a negocios', icon: 'payments', path: '/admin/staff/settlements' },
      { label: 'Facturación anterior', icon: 'receipt_long', path: '/admin/staff/billing' },
    ] }];
  }
  if (area === 'admin') {
    return [
      { label: 'Tu negocio', links: [
        { label: 'Inicio', icon: 'space_dashboard', path: '/admin/dashboard' },
        { label: 'Próximos eventos', icon: 'event', path: '/admin/events-future' },
        { label: 'Eventos anteriores', icon: 'history', path: '/admin/events-past' },
        { label: 'Cartas de barra', icon: 'menu_book', path: '/admin/menus' },
      ] },
      { label: 'Personas', links: [
        { label: 'Equipo del negocio', icon: 'badge', path: '/admin/staff-qr' },
        { label: 'Clientes', icon: 'group', path: '/admin/clients' },
      ] },
      { label: 'Cobros', links: [
        { label: 'Saldo y liquidaciones', icon: 'payments', path: '/admin/settlements' },
        { label: 'Medios de cobro', icon: 'account_balance_wallet', path: '/admin/mercado-pago' },
        { label: 'Cuentas bancarias', icon: 'account_balance', path: '/admin/banks' },
      ] },
    ];
  }
  return [
    { label: 'Tu turno', links: [
      { label: 'Inicio', icon: 'space_dashboard', path: '/workers/dashboard' },
      { label: 'Validar entradas', icon: 'qr_code_scanner', path: '/workers/events' },
      { label: 'Entregar pedidos', icon: 'local_bar', path: '/workers/menus' },
    ] },
    { label: 'Registros', links: [
      { label: 'Historial de accesos', icon: 'history', path: '/workers/history-access' },
      { label: 'Historial de barra', icon: 'receipt_long', path: '/workers/history-bar' },
      ...(user.isAdmin ? [{ label: 'Mesas del evento', icon: 'table_restaurant', path: '/workers/tables' }] : []),
    ] },
  ];
}

export function operationsParent(url: string): OperationsLink | null {
  const path = url.split(/[?;]/)[0];
  if (/^\/admin\/events\/[^/]+\/sales$/.test(path)) return { label: 'Eventos', icon: 'arrow_back', path: '/admin/events-future' };
  if (/^\/admin\/menus\/[^/]+/.test(path)) return { label: 'Cartas', icon: 'arrow_back', path: '/admin/menus' };
  if (path.startsWith('/workers/events/qr/')) return { label: 'Eventos asignados', icon: 'arrow_back', path: '/workers/events' };
  if (path.startsWith('/workers/menus/qr/')) return { label: 'Barras asignadas', icon: 'arrow_back', path: '/workers/menus' };
  return null;
}
